import aquaLogo from './assets/aqua-logo.svg?react'
import dcsLogo from './assets/dcs-logo.svg?react'
import hmLogo from './assets/hm-logo.svg?react'
import lmLogo from './assets/lm-logo.svg?react'
import mnpLogo from './assets/mnp-logo.svg?react'
import rsLogo from './assets/rs-logo.svg?react'
import { createSvgIcon } from './createSvgIcon'

export const DCSLogo = createSvgIcon(dcsLogo)
export const LMLogo = createSvgIcon(lmLogo)
export const HMLogo = createSvgIcon(hmLogo)
export const MNPLogo = createSvgIcon(mnpLogo)
export const AquaLogo = createSvgIcon(aquaLogo)
export const RSLogo = createSvgIcon(rsLogo)

export const logoMap = {
  dcs: DCSLogo,
  lm: LMLogo,
  hm: HMLogo,
  mnp: MNPLogo,
  aqua: AquaLogo,
  rs: RSLogo,
}
